var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVisualizationSelectionStackedLine = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#81848F",
  d: "M1 47h47v1H0V0h1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#81848F",
  d: "M5 32h10v11H5zm14-8h10v19H19zm14 4h10v15H33z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C0C1C7",
  d: "M5 25h10v6H5zm14-10h10v8H19zm14 4h10v8H33zm2.245-12.581a2.5 2.5 0 1 1-.071 1.999l-9.243-.33a2.501 2.501 0 0 1-4.509.803l-9.424 3.702a2.5 2.5 0 1 1-.731-1.862l9.811-3.854a2.501 2.501 0 0 1 4.475-.804z"
}))));
export default SvgVisualizationSelectionStackedLine;